import { render, staticRenderFns } from "./about-curva.vue?vue&type=template&id=7d90442a&"
import script from "./about-curva.vue?vue&type=script&lang=js&"
export * from "./about-curva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports